import React from 'react';
import styles from './TextEffectsMatrix.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import clsx from 'clsx';

export type TextEffectsMatrixProps = TextEffectsSharedProps;

const TextEffectsMatrix: React.FC<TextEffectsSharedProps> = props => {
  const { text, reducedMotion } = props;

  return (
    <TextEffectsShared {...props}>
      <div className={styles.container} data-testid={TestIds.viewer.container}>
        <div
          className={clsx(styles.wrapper, {
            [styles.reducedMotion]: reducedMotion,
          })}
          data-text={text}
        >
          <div data-testid={TestIds.viewer.text} className={styles.text}>
            {text}
          </div>
        </div>
      </div>
    </TextEffectsShared>
  );
};

export default TextEffectsMatrix;
